import { useApolloClient } from '@apollo/client'
import type { AvailableIntegrationsQuery } from 'generated/resources/graphql'
import {
  SyncableStateFragmentDoc,
  SyncableStateUpdatedDocument,
} from 'generated/resources/graphql'

type MarketplaceDbIntegration =
  AvailableIntegrationsQuery['integrations']['availableIntegrationsConnection']['nodes'][number]['marketplaceIntegration']

import { useSubscription } from 'modules/core/hooks/useSubscription'

interface UseSyncableStateUpdatedSubscriptionProps {
  marketplaceIntegration: MarketplaceDbIntegration | null
  syncEnabled: boolean
}

export const useSyncableStateUpdatedSubscription = ({
  marketplaceIntegration,
  syncEnabled,
}: UseSyncableStateUpdatedSubscriptionProps) => {
  const client = useApolloClient()

  useSubscription(SyncableStateUpdatedDocument, {
    onData: ({ data: subscriptionData }) => {
      const syncableState = subscriptionData.data?.integrationsSyncableStateUpdate?.syncableState
      if (
        !syncableState ||
        syncableState.syncableType !== 'compensationscompensation' ||
        !marketplaceIntegration
      )
        return
      const compensationKey = `CompensationsPayrollRunEmployeesCompensation:${syncableState.syncableId}`
      client.writeFragment({
        id: compensationKey,
        variables: {
          marketplaceIntegrationId: marketplaceIntegration.id,
          syncableType: 'compensationscompensation',
        },
        fragment: SyncableStateFragmentDoc,
        fragmentName: 'SyncableState',
        data: {
          syncableState: [
            {
              id: syncableState.id,
              status: syncableState.status,
              errorMessages: syncableState.errorMessages,
              marketplaceIntegrationId: marketplaceIntegration.id,
              statusUpdatedAt: syncableState.statusUpdatedAt,
              syncableId: syncableState.syncableId,
              syncableType: syncableState.syncableType,
              __typename: 'IntegrationsSyncableState',
            },
          ],
          __typename: 'CompensationsPayrollRunEmployeesCompensation',
        },
      })
    },
    skip: !syncEnabled,
  })
}
